// 文章101数据信息
export default {
  id: '101',
  title: '合作医院介绍',
  createTime: '2025-04-21 09:00:00',
  content: `### 暨南大学附属第一医院

![img](https://cdn.keihong.tech/img/20250421200215732.png)

![img](https://cdn.keihong.tech/img/20250421200216376.png)

**简介**：华南地区综合实力前十的三甲医院，其康复科是广东省临床重点专科，形成神经康复、骨科康复、言语吞咽康复三大核心方向。科室拥有国内领先的"语言障碍诊治中心"，开发的ZM2.1语言障碍治疗仪覆盖全国80%以上三甲医院。在神经康复领域，开展脊髓损伤步行训练、脑机接口康复等前沿技术；骨科康复团队年均完成关节置换术后康复超3000例，采用"早期介入-强化训练-居家指导"模式，患者功能恢复优良率达92%。

### 暨南大学附属顺德医院

![img](https://cdn.keihong.tech/img/20250421200216172.png)

![img](https://cdn.keihong.tech/img/20250421200218512.png)

**简介**：作为国家三级综合医院，暨南大学附属顺德医院以"中西医结合康复"为特色，其康复医学科是佛山市"十四五"中医特色专科，擅长脑卒中吞咽障碍、骨科术后及老年慢性病康复。科室配备智能康复机器人、经颅磁刺激仪等先进设备，创新开展"吞咽障碍阶梯式康复方案"，曾获全国医院擂台赛卓越案例奖。医院通过"互联网+护理"实现康复服务延伸，构建了从急性期救治到社区康复的全周期服务体系，年服务康复患者超万人次。

### 广州中医药大学顺德医院

![img](https://cdn.keihong.tech/img/20250421200216291.png)

![img](https://cdn.keihong.tech/img/20250421200220453.png)

**简介**：三级甲等中医院，康复科是佛山市"十四五"中医重点专科，创新"中医筋骨并重"康复模式。科室融合南少林骨伤流派手法、温针火疗等传统技术与现代康复设备，在骨伤康复领域年均收治脊柱侧弯、关节置换术后患者超2000例。特色开展"脊髓损伤中医康复包"服务，结合中药熏蒸、督灸等疗法，使脊髓损伤患者步行功能恢复率提升35%。医院新城院区设94张康复床位，配备冲击波治疗仪、悬吊训练系统等先进设备。

### 东莞康华医院

![img](https://cdn.keihong.tech/img/20250421200216347.png)

![img](https://cdn.keihong.tech/img/20250421200217070.png)

**简介**：民营三甲综合医院，康复科是东莞市临床重点专科，在重症康复领域形成显著优势。科室创新性开展声门下正压治疗技术，成功帮助气管切开患者恢复言语功能，相关案例被《成人气管切开拔管中国专家共识》收录。配备3000㎡康复大厅，拥有力感减重下肢康复机器人、智能转移系统等设备，年均完成脊髓损伤康复超500例。在吞咽障碍治疗领域，采用导管球囊扩张术联合生物反馈技术，使吞咽功能恢复有效率达89%。

### U康来互联网医院

![img](https://cdn.keihong.tech/img/20250421200216831.png)

**简介**：国家卫健委立项的脑血管病专病管理平台，构建"检存管医康保"全流程数字化服务体系。平台整合全国200余家三甲医院资源，提供脑卒中远程康复评估、AI康复方案生成、居家设备联动等服务。特色开展"卒中康复地图"功能，实时匹配患者与就近康复机构；创新"疗效保障"机制，承诺一年内复发给予住院费用补贴。平台累计服务患者超10万人，使居家康复依从性提升40%。`
}
